// extracted by mini-css-extract-plugin
module.exports = {"stackedAreaContainer":"StackedArea_stackedAreaContainer__3aUoV"};